import { useContext } from 'react';
import { ThemeContext, ThemeUpdateContext } from '../context';
export function useTheme() {
    const theme = useContext(ThemeContext);
    const setTheme = useContext(ThemeUpdateContext);
    return [theme, setTheme];
}
